import { injectParams } from "@/lib/router/use-workspace-navigate";
import { type ComponentPropsWithoutRef, forwardRef } from "react";
import { NavLink, useParams } from "react-router";

/**
 * Props for the WorkspaceLink component
 */
export type WorkspaceLinkProps = Omit<ComponentPropsWithoutRef<typeof NavLink>, "to"> & {
  to: string;
};

/**
 * A Link component that automatically injects the current workspaceId into the 'to' prop
 */
export const WorkspaceLink = forwardRef<HTMLAnchorElement, WorkspaceLinkProps>(({ to, ...rest }, ref) => {
  const { workspaceId } = useParams<{ workspaceId: string }>();

  if (workspaceId == null) {
    return <NavLink ref={ref} to={to} {...rest} />;
  }

  return <NavLink ref={ref} to={injectParams(to, { workspaceId })} {...rest} />;
});

WorkspaceLink.displayName = "WorkspaceLink";
